/**
 * General helpers.
 *
 * Prefer named imports:
 *   import { minutesToText, groupObjectsByKey } from '@/services/Functions'
 *
 * Legacy Options API still uses this.$F.g.*
 */

export function allCountries() {
  return [
    'Afeganistão',
    'África do Sul',
    'Albânia',
    'Alemanha',
    'Andorra',
    'Angola',
    'Antiga e Barbuda',
    'Arábia Saudita',
    'Argélia',
    'Argentina',
    'Arménia',
    'Austrália',
    'Áustria',
    'Azerbaijão',
    'Bahamas',
    'Bangladexe',
    'Barbados',
    'Barém',
    'Bélgica',
    'Belize',
    'Benim',
    'Bielorrússia',
    'Bolívia',
    'Bósnia e Herzegovina',
    'Botsuana',
    'Brasil',
    'Brunei',
    'Bulgária',
    'Burquina Faso',
    'Burúndi',
    'Butão',
    'Cabo Verde',
    'Camarões',
    'Camboja',
    'Canadá',
    'Catar',
    'Cazaquistão',
    'Chade',
    'Chile',
    'China',
    'Chipre',
    'Colômbia',
    'Comores',
    'Congo-Brazzaville',
    'Coreia do Norte',
    'Coreia do Sul',
    'Cosovo',
    'Costa do Marfim',
    'Costa Rica',
    'Croácia',
    'Cuaite',
    'Cuba',
    'Dinamarca',
    'Dominica',
    'Egito',
    'Emirados Árabes Unidos',
    'Equador',
    'Eritreia',
    'Eslováquia',
    'Eslovénia',
    'Espanha',
    'Essuatíni',
    'Estado da Palestina',
    'Estados Unidos',
    'Estónia',
    'Etiópia',
    'Fiji',
    'Filipinas',
    'Finlândia',
    'França',
    'Gabão',
    'Gâmbia',
    'Gana',
    'Geórgia',
    'Granada',
    'Grécia',
    'Guatemala',
    'Guiana',
    'Guiné',
    'Guiné Equatorial',
    'Guiné-Bissau',
    'Haiti',
    'Honduras',
    'Hungria',
    'Iémen',
    'Ilhas Marechal',
    'Índia',
    'Indonésia',
    'Irão',
    'Iraque',
    'Irlanda',
    'Islândia',
    'Israel',
    'Itália',
    'Jamaica',
    'Japão',
    'Jibuti',
    'Jordânia',
    'Laus',
    'Lesoto',
    'Letónia',
    'Líbano',
    'Libéria',
    'Líbia',
    'Listenstaine',
    'Lituânia',
    'Luxemburgo',
    'Macedónia do Norte',
    'Madagáscar',
    'Malásia',
    'Maláui',
    'Maldivas',
    'Mali',
    'Malta',
    'Marrocos',
    'Maurícia',
    'Mauritânia',
    'México',
    'Mianmar',
    'Micronésia',
    'Moçambique',
    'Moldávia',
    'Mónaco',
    'Mongólia',
    'Montenegro',
    'Namíbia',
    'Nauru',
    'Nepal',
    'Nicarágua',
    'Níger',
    'Nigéria',
    'Noruega',
    'Nova Zelândia',
    'Omã',
    'Países Baixos',
    'Palau',
    'Panamá',
    'Papua Nova Guiné',
    'Paquistão',
    'Paraguai',
    'Peru',
    'Polónia',
    'Portugal',
    'Quénia',
    'Quirguistão',
    'Quiribáti',
    'Reino Unido',
    'República Centro-Africana',
    'República Checa',
    'República Democrática do Congo',
    'República Dominicana',
    'Roménia',
    'Ruanda',
    'Rússia',
    'Salomão',
    'Salvador',
    'Samoa',
    'Santa Lúcia',
    'São Cristóvão e Neves',
    'São Marinho',
    'São Tomé e Príncipe',
    'São Vicente e Granadinas',
    'Seicheles',
    'Senegal',
    'Serra Leoa',
    'Sérvia',
    'Singapura',
    'Síria',
    'Somália',
    'Sri Lanca',
    'Suazilândia',
    'Sudão',
    'Sudão do Sul',
    'Suécia',
    'Suíça',
    'Suriname',
    'Tailândia',
    'Taiuã',
    'Tajiquistão',
    'Tanzânia',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trindade e Tobago',
    'Tunísia',
    'Turcomenistão',
    'Turquia',
    'Tuvalu',
    'Ucrânia',
    'Uganda',
    'Uruguai',
    'Usbequistão',
    'Vanuatu',
    'Vaticano',
    'Venezuela',
    'Vietname',
    'Zâmbia',
    'Zimbábue',
  ]
}

export function allBrazilianStates() {
  return [
    { title: 'Outro (fora do Brasil)', uf: 'ZZ' },
    { title: 'Acre (AC)', uf: 'AC' },
    { title: 'Alagoas (AL)', uf: 'AL' },
    { title: 'Amapá (AP)', uf: 'AP' },
    { title: 'Amazonas (AM)', uf: 'AM' },
    { title: 'Bahia (BA)', uf: 'BA' },
    { title: 'Ceará (CE)', uf: 'CE' },
    { title: 'Distrito Federal (DF)', uf: 'DF' },
    { title: 'Espírito Santo (ES)', uf: 'ES' },
    { title: 'Goiás (GO)', uf: 'GO' },
    { title: 'Maranhão (MA)', uf: 'MA' },
    { title: 'Mato Grosso (MT)', uf: 'MT' },
    { title: 'Mato Grosso do Sul (MS)', uf: 'MS' },
    { title: 'Minas Gerais (MG)', uf: 'MG' },
    { title: 'Pará (PA)', uf: 'PA' },
    { title: 'Paraíba (PB)', uf: 'PB' },
    { title: 'Paraná (PR)', uf: 'PR' },
    { title: 'Pernambuco (PE)', uf: 'PE' },
    { title: 'Piauí (PI)', uf: 'PI' },
    { title: 'Rio de Janeiro (RJ)', uf: 'RJ' },
    { title: 'Rio Grande do Norte (RN)', uf: 'RN' },
    { title: 'Rio Grande do Sul (RS)', uf: 'RS' },
    { title: 'Rondônia (RO)', uf: 'RO' },
    { title: 'Roraima (RR)', uf: 'RR' },
    { title: 'Santa Catarina (SC)', uf: 'SC' },
    { title: 'São Paulo (SP)', uf: 'SP' },
    { title: 'Sergipe (SE)', uf: 'SE' },
    { title: 'Tocantins (TO)', uf: 'TO' },
  ]
}

export function minutesToText(min) {
  const hours = Math.floor(min / 60)
  const minutes = min - hours * 60
  let text = ''
  if (hours > 0) text += `${hours}h`
  if (minutes > 0) text += `${minutes}min`
  return text
}

export function groupObjectsByKey(objects, key) {
  const groupedArrays = []
  objects.forEach((obj) => {
    const value = obj[key]
    let found = false
    groupedArrays.forEach((groupedArr) => {
      if (groupedArr[0][key] === value) {
        groupedArr.push(obj)
        found = true
      }
    })
    if (!found) {
      groupedArrays.push([obj])
    }
  })
  return groupedArrays
}

export function isAPP() {
  return window?.cordova ? true : false
}

export function iOS() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  let uaIOS = /iPhone|iPad|iPod/i.test(
    navigator?.userAgent ||
      navigator?.vendor ||
      (window.opera && opera.toString() === '[object Opera]')
  )
  let isIOS = uaIOS
  if (window?.cordova?.platformId) {
    isIOS = window?.cordova?.platformId == 'ios'
  }
  return isIOS
}

export function openTelegram(chatId) {
  window.open(`https://telegram.me/${chatId}`, '_system')
}

/** Legacy bag for this.$F.g */
export const g = {
  allCountries,
  allBrazilianStates,
  minutesToText,
  groupObjectsByKey,
  isAPP,
  iOS,
  openTelegram,
}

export default { g }
